<template>
  <div>
    <!-- Loading -->
    <div v-if="isLoading">
      <LoadingSpinner />
    </div>
    <div v-else>
      <div v-if="recessoData" class="card card-body shadow-sm mt-0">
        <div class="header d-flex justify-content-between align-items-center">
          <h4 class="form-title">
            Detalhes do Recesso:
            <span v-if="recessoData.id">{{ recessoData.id }}</span>
          </h4>
          <button class="btn btn-secondary" @click="voltar">Voltar</button>
        </div>

        <div class="form-content mt-3">
          <FormSection title="Dados do Recesso">
            <p><strong>Início:</strong> {{ formatarData(recessoData.data_inicio) }}</p>
            <p><strong>Fim:</strong> {{ formatarData(recessoData.data_fim) }}</p>
            <p><strong>Descrição:</strong> {{ recessoData.descricao }}</p>
            <p><strong>Aplicado:</strong> {{ recessoData.aplicado ? 'Sim' : 'Não' }}</p>
            <p><strong>Cadastrado por:</strong> {{ recessoData.por }}</p>
          </FormSection>
          <FormSection title="Alteração das datas de vigência">
        <p class="recesso-info">
        1. Os planos com final da vigência prevista para após a data de fim, terão os dias de recesso adicionados à vigência.
        </p>
        <p class="recesso-info">
        2. Os planos com final da vigência prevista para o período do recesso, terão os dias proporcionais adicionados à vigência.
        </p>
          </FormSection>
        </div>
      </div>
      <div v-else>
        <p>Nenhum recesso encontrado.</p>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import axios from '@/services/axios'
import FormSection from '@/components/Layout/FormSection.vue'
// import LoadingSpinner from '@/components/LoadingSpinner.vue'
import globalUtils from '@/utils/globalUtils.js'

export default {
  name: 'DetalharRecesso',
  components: { FormSection },
  setup() {
    const route = useRoute()
    const router = useRouter()
    const isLoading = ref(true)
    const recessoData = ref(null)

    const carregarRecesso = async (id) => {
      try {
        const response = await axios.get(`/configuracoes/recessos/${id}`)
        recessoData.value = response.data
      } catch (error) {
        console.error('Erro ao carregar recesso:', error)
      } finally {
        isLoading.value = false
      }
    }

    const voltar = () => router.push('/configuracoes/recessos')

    onMounted(() => {
      if (route.params.id) carregarRecesso(route.params.id)
      else isLoading.value = false
    })

    return { isLoading, recessoData, voltar, formatarData: globalUtils.formatarData }
  }
}
</script>

<style scoped>
.card {
  margin: 20px;
}
.form-title {
  font-size: 1.25rem;
  font-weight: bold;
}
</style>
